import FormButton from "components/form/FormButton";
import cssQrPopup from "../qrpopup.module.scss";

interface QrPopupProps {
  homeName: string;
  qrImgData: string;
  actionUpdateSigninQR: () => void;
  setShowQr: (show: boolean) => void;
  _: (section: string, key: string) => string;
  savePNGFile: (data: string, filename: string, isBase64?: boolean) => void;
}

const QrPopup = ({
  homeName,
  qrImgData,
  actionUpdateSigninQR,
  setShowQr,
  _,
  savePNGFile,
}: QrPopupProps) => {
  const handleSendQr = async () => {
    try {
      // Try sharing via Web Share API with a file if supported
      const res = await fetch(qrImgData);
      const blob = await res.blob();
      const fileName = `${homeName || "qr"}.png`;
      const file = new File([blob], fileName, {
        type: blob.type || "image/png",
      });

      if (
        (navigator as any).canShare &&
        (navigator as any).canShare({ files: [file] })
      ) {
        await (navigator as any).share({
          files: [file],
          title: `QR code for ${homeName || ""}`,
          text: "Scan this QR code to sign in.",
        });
        return;
      }

      // // Fallback: save the PNG locally and open a mailto link
      // savePNGFile(qrImgData, homeName || "qr", true);
      // const to = window.prompt("Enter recipient email address:");
      // if (to) {
      //   const subject = encodeURIComponent(`QR code for ${homeName || ""}`);
      //   const body = encodeURIComponent(
      //     "Hi,\n\nPlease find the QR code image downloaded to your computer. Attach it to this email and send.\n\nScan this QR code to sign in.\n",
      //   );
      //   window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
      // }
    } catch (e) {
      // As a last resort, just trigger the download
      // savePNGFile(qrImgData, homeName || "qr", true);
    }
  };
  return (
    <div className={cssQrPopup.popupWrapper}>
      <div className={cssQrPopup.popup}>
        <button
          className={cssQrPopup.closeButton}
          aria-label={_("general", "btn_close")}
          onClick={() => setShowQr(false)}
        >
          ×
        </button>
        <div className={cssQrPopup.heading}>
          {`${_("general", "qr_code_for")} ${homeName || ""}`}
        </div>
        <img className={cssQrPopup.qrCode} src={qrImgData} alt="QR"></img>
        <div className={cssQrPopup.buttons}>
          {/* <FormButton
            label={_("account", "btn_regenerate_qr")}
            onSubmit={(event) => actionUpdateSigninQR()}
            variant={"outlined"}
          />
          <FormButton
            label={_("general", "btn_print")}
            onSubmit={(event) => window.print()}
            variant={"outlined"}
          />
          */}
          <FormButton
            label={_("general", "send_qr_code")}
            onSubmit={handleSendQr}
            dontTransformToUppercase
            color="darkerGreen"
            heightPx={45}
          />
          <FormButton
            label={_("general", "btn_download")}
            onSubmit={() => savePNGFile(qrImgData, homeName || "qr", true)}
            dontTransformToUppercase
            variant="outlined"
            heightPx={45}

            // color="darkerGreen"

            // variant={"outlined"}
          />
        </div>
      </div>
    </div>
  );
};

export default QrPopup;
